import { useStateData } from "../hooks/useStateData";
import { Routing } from "./Routing";

export const StateGlobalState = () => {
  useStateData();

  return <Routing />;
};
